import React from 'react';
import PropTypes from 'prop-types';

export const LogoWhite = props => {
  const isSmall = props.isSmall || false;

  const [width, height] = isSmall ? ['74px', '13px'] : ['118px', '21px'];

  return <img src="img/logo-white.svg" style={{ width, height, minWidth: width, minHeight: height }} />;
};

LogoWhite.propTypes = {
  isSmall: PropTypes.bool,
};

export const LogoBlack = props => {
  const isSmall = props.isSmall || false;

  const [width, height] = isSmall ? ['74px', '13px'] : ['118px', '21px'];

  return <img src="img/logo-black.svg" style={{ width, height, minWidth: width, minHeight: height }} />;
};

LogoBlack.propTypes = {
  isSmall: PropTypes.bool,
};

export default {
  White: LogoWhite,
  Black: LogoBlack,
};
